import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-emp-mastergrid',
  templateUrl: './emp-mastergrid.component.html',
  styleUrls: ['./emp-mastergrid.component.scss']
})
export class EmpMastergridComponent implements OnInit {

  constructor(public appservice: AppService, public location: Location, public router: Router, public cdr: ChangeDetectorRef) { }
  employees = [
    { id: 1, name: 'Alice', department: 'HR', salary: 50000 },
    { id: 2, name: 'Bob', department: 'Engineering', salary: 75000 },
    { id: 3, name: 'Charlie', department: 'Marketing', salary: 60000 }
  ];
    public searchText: string = '';
  public employeemasterdata1: any = {}
  public employeemasterdatas: any[] = []
  getempployeemaster() {
    this.appservice.getTable("api/Master/getemployeedetails").subscribe((res: any) => {
      this.employeemasterdata1 = JSON.parse(res);
      //console.log("the values",this.employeemasterdata);
    });
  }
  editEmployee(data) {
    this.appservice.empmastereditid = data;
    console.log("the edit id", this.appservice.empmastereditid);
    this.router.navigate(['/home/employeemaster'])
  }
  deleteEmployee(id: any) {
    if (confirm("Are you sure to delete the record?")) {
      this.appservice.getTable("api/Master/delete_EmployeeMaster?empid=" + id).subscribe((res: any) => {
        if (res != '') {
          this.refresh();
          this.appservice.getempployeemaster();
        }
      });
    }
  }
  gotoempmaster() {
    this.appservice.empmastereditid = '';
    return this.router.navigate(['/home/employeemaster'])
  }

  filterEmployees() {

  if (!this.searchText) {
    this.refresh();
    return;
  }

  const search = this.searchText.toLowerCase();

  this.employeemasterdatas = this.employeemasterdatas.filter((emp: any) =>

    (emp.Em_Empcode || '').toLowerCase().includes(search) ||
    (emp.Em_First_Name || '').toLowerCase().includes(search) ||
    (emp.Em_lastName || '').toLowerCase().includes(search) ||
    (emp.Em_Designation || '').toLowerCase().includes(search) ||
    (emp.Em_Department || '').toLowerCase().includes(search)

  );
}
  refresh() {
    this.appservice.getTable("api/Master/getemployeedetails").subscribe((res: any) => {
      if (typeof res === 'string') {
        try {
          // Remove control characters before parsing
          const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
          this.employeemasterdatas = JSON.parse(clean);
        } catch (e) {
          console.error("Cleaned JSON parse error:", e);
          this.employeemasterdatas = [];
        }
      } else {
        this.employeemasterdatas = res;
      }
    });
  }
  ngOnInit(): void {
    //this.employeemasterdatas=this.appservice.getempployeemaster();
    this.appservice.getTable("api/Master/getemployeedetails").subscribe((res: any) => {
      if (typeof res === 'string') {
        try {
          // Remove control characters before parsing
          const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
          this.employeemasterdatas = JSON.parse(clean);
        } catch (e) {
          console.error("Cleaned JSON parse error:", e);
          this.employeemasterdatas = [];
        }
      } else {
        this.employeemasterdatas = res;
      }
    });
  }

}
